<template>
	<li class="list-group-item" :data-address="addressId" :data-product="orderProductId" :data-action="editUrl">
		<div class="row">
			<div class="col-6 col-md-7 address">{{ productName }} -- {{ street }} {{ streetNumber }}, {{ postalcode }} {{ city }}</div>
			<template v-if="allow_edit == 0">
			<div class="col-4 col-md-3 amount text-right">
					{{ amount }} rr
			</div>
			</template>
			<template v-else>
			<div class="col-4 col-md-3 amount text-right input-group">
					<input class="form-control" name="amount" :value="amount" ref="amount"/>
					<div class="input-group-append"><span class="input-group-text">rr</span></div>
			</div>
			</template>
			<div class="col-2 col-md-2 buttons text-right" v-if="allow_edit == 1">
				<a class="delete" :href="deleteUrl"><i class="fa fa-trash text-danger"></i></a>
			</div>
		</div>
	</li>
</template>

<script>
	export default {
		name: 'ProductAddress',
		props: {
			'orderId': { required: true, type: Number },
			'addressId': { required: true, type: Number },
			'orderProductId': { required: true, type: Number },
			'amount': { required: true, type: Number },
			'street': { required: true, type: String },
			'postalcode': { required: true, type: String },
			'city': { required: true, type: String },
			'streetNumber': { required: true, type: String },
			'productName': { required: true, type: String },
			'path': { required: true, type: String },
			'allow_edit': { required: true, type: Number },
		},
		data: function () {
			return {
				'deleteUrl': '/'+this.path+'/'+ this.orderId +'/product/'+ this.orderProductId +'/address/' + this.addressId +'/delete',
				'editUrl': '/'+this.path+'/'+ this.orderId +'/product/'+ this.orderProductId +'/address/' + this.addressId +'/edit',
				'locale': 'nl'
			}
		},
		watch: {
			locale (val) {
				this.$i18n.locale = val
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/declaration/ProductAddress.vue